/* eslint-disable no-console */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Link } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types'; // eslint-disable-line no-restricted-imports
import cx from 'classnames';

import dayjs from 'dayjs';

import { replaceHyphensWithSpace, upperCaseString } from 'Utilities/breadcrumbs';
import metatitle from 'Utilities/metatitle';
import { assignSectionRoutes } from 'Utilities/routing';
import T from 'Utilities/texts';
import { fetchBlogData, fetchPageData, getGuidePage } from 'Utilities/wordpressPages';

import { Content } from 'LegacySBCRA/Content/Content';
import { Title } from 'Storybook/components/local/Title/Title';

import StickyVRM from '../../../../components/misc/StickyVRM/StickyVRM';
import DialogLoader from '../../../../components/transitions/DialogLoader/DialogLoader';
import BlogPost from '../../../../components/wordpress/blog/BlogPost';
import Page from '../../../../components/wordpress/page/Page';
import { connect } from '../../../../store';
import Status404 from '../../error/404';
import Breadcrumbs from '../../fastlane/breadcrumbs/Breadcrumbs';

import VrmCheckerWrapper from './VrmCheckerWrapper/VrmCheckerWrapper';

import styles from './Wordpress.scss';

class Wordpress extends React.PureComponent {
  constructor(props) {
    super(props);

    this.$content = React.createRef();

    this.state = {
      archive: [],
      blog: false,
      content: null,
      ready: true,
      stickyVRM: false,
    };
  }

  componentDidMount() {
    const { context } = this.props;
    const { wordpressData } = context.state; // __INITIAL_STATE__.wordpressData

    this.mq = window.matchMedia(`(max-width: ${styles.breakpointTablet})`); // For sticky VRM
    this.mq.addListener(this.handleResize);

    this.setState({
      isTablet: this.mq.matches,
    });

    setTimeout(() => {
      this.setState({
        stickyVRM: true,
      });
    }, 500);

    if (wordpressData) {
      // SSR __INITIAL_STATE__.wordpressData has data
      if (wordpressData.posts !== undefined && wordpressData.posts.length > 0) { // Index page, not a post
        const { match } = this.props;

        let hasPageTitle = false;
        if ((match.params.year || match.params.month || match.params.day) && (!match.params.post)) {
          hasPageTitle = true;
        }

        this.setState({
          archive: wordpressData.archive,
          blog: true,
          content: (
            <div>
              {wordpressData.posts.map((p, index) => (
                <BlogPost
                  key={`post-${index}`}
                  author={p.author}
                  className={index === 0 && !hasPageTitle ? styles.noTopMargin : null}
                  content={match.params.post ? p.content : p.excerpt}
                  date={p.date}
                  noLink={!!match.params.post}
                  slug={p.slug}
                  title={p.title}
                  wordpressContent={{
                    className: styles.wordpressContent,
                  }}
                />
              ))}
            </div>
          ),
          ready: true,
        });
      } else { // Post
        this.setState({
          content: (<Page
            content={wordpressData.content}
            title={wordpressData.title}
            wordpressContent={{
              className: styles.wordpressContent,
            }}
          />),
          ready: true,
        });
      }
    } else {
      // CSR route triggering, no SSR data
      this.generatePage();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { location, match } = this.props;
    const { ready } = this.state;
    if (match.url !== prevProps.match.url) {
      this.generatePage();
    }

    if (location.hash) {
      this.scrollToHashBlock();
    }

    if (ready && !prevState.ready) {
      // Allow images to load in for accurate height
      clearTimeout(this.newContentTimer);
      this.newContentTimer = setTimeout(() => {
        this.setState({
          stickyVRM: true,
        });

        try {
          this.scrollToHashBlock();
        } catch {
          // No catch
        }
      }, 600);
    }
  }

  componentWillUnmount() {
    this.mq.removeListener(this.handleResize);
    this.clearTimers();
  }

  clearTimers = () => {
    clearTimeout(this.foucTimeout);
    clearTimeout(this.newContentTimer);
  };

  handleResize = () => {
    this.setState({
      isTablet: this.mq.matches,
    });
  };

  displayPage = (wordpressData) => {
    const { match } = this.props;
    let path = match.path.substring(1);

    if (path === 'guides/:subdir?') {
      const [first] = path.split('/');
      path = first;
    }

    return (
      <Page
        content={wordpressData.content}
        title={wordpressData.title}
        wordpressContent={{
          className: `${styles.wordpressContent} ${styles.wordpressContent}_content_${path}`,
        }}
        wordpressData={wordpressData}
      />
    );
  };

  generatePage = () => {
    const { context, match } = this.props;

    this.clearTimers();

    this.setState({
      preventFouc: true,
      ready: false,
      stickyVRM: false,
    });

    // Prevent a very brief distracting loading state while the XHR happens
    this.foucTimeout = setTimeout(() => {
      this.setState({
        preventFouc: false,
      });
    }, 300);

    context.update({ wordpressData: null }); // Wipe the SSR data

    let { url } = match;
    const originalUrl = url;

    const { isBlogRoute, isGuideRoute } = assignSectionRoutes(match.path); // https://github.com/motorway/motorway-seller-webapp#wordpress-content

    if (match.params && match.params.subdir) {
      url = match.params.subdir;
    }

    if (isBlogRoute) {
      url = 'blog';
    }

    const processWpContent = (data) => {
      clearTimeout(this.foucTimeout);

      metatitle.formatTitle(match.url, data.meta.title);
      metatitle.formatDescription(data.meta.desc || 'Compare car buyers');

      if (isBlogRoute) {
        this.generatePosts();
      } else {
        this.setState({
          blog: false,
          content: (<Page
            content={data.content}
            title={data.title}
            wordpressContent={{
              className: styles.wordpressContent,
            }}
          />),
          ready: true,
        });
      }
    };

    const processWpContentError = (err) => {
      console.error(err);
      clearTimeout(this.foucTimeout);
    };

    if (isGuideRoute) {
      getGuidePage({ route: match.params.subdir, slug: originalUrl })
        .then(processWpContent)
        .catch(processWpContentError);
      return;
    }

    fetchPageData(url, isGuideRoute)
      .then(processWpContent)
      .catch(processWpContentError);
  };

  generatePosts = () => {
    const { match } = this.props;
    const { url } = match;
    const blogUrl = match.url.split('/')[1];

    fetchBlogData(url).then((data) => {
      if (data && data.posts.length > 0) {
        let hasPageTitle = false;
        if ((match.params.year || match.params.month || match.params.day) && (!match.params.post)) {
          hasPageTitle = true;
        }
        const content = data.posts.map((p, index) => (
          <BlogPost
            key={`post-${index}`}
            author={p.author}
            className={index === 0 && !hasPageTitle ? styles.noTopMargin : null}
            content={match.params.post ? p.content : p.excerpt}
            date={p.date}
            noLink={!!match.params.post}
            slug={p.slug}
            title={p.title}
            wordpressContent={{
              className: `${styles.wordpressContent} ${styles.wordpressContent}_content_${blogUrl}`,
            }}
          />
        ));

        // Update meta
        if (data.meta && data.meta.title) {
          metatitle.formatTitle(match.url, data.meta.title);
          metatitle.formatDescription(data.meta.desc || 'Compare car buyers');
        }

        this.setState({
          archive: data.archive,
          blog: true,
          content: (<div>{content}</div>),
          ready: true,
        });
      } else {
        const content = (
          <div className={styles.empty}>No posts to show.</div>
        );

        // No posts!
        this.setState({
          blog: true,
          content: (<div>{content}</div>),
          ready: true,
        });
      }
    }).catch((err) => {
      this.setState({
        content: null,
        ready: true,
      });

      console.error(err);
    });
  };

  scrollToHashBlock() {
    const { location } = this.props;
    const elem = document.getElementById(location.hash.replace('#', ''));
    if (elem) {
      window.scrollTo(0, elem.offsetTop - 64);
    }
  }

  render() {
    const { context } = this.props;
    const { wordpressData } = context.state;
    let {
      archive,
      blog,
      content,
      isTablet,
      preventFouc,
      ready,
      stickyVRM,
    } = this.state;

    if (wordpressData && wordpressData.content && wordpressData.content.archive) {
      archive = wordpressData.content.archive;
    }

    // render error page instead of an empty page if there's no WP content and posts data for the page
    if (wordpressData?.content === null && !wordpressData?.posts.length) {
      return (<Status404 />);
    }

    const topNav = [{
      label: 'Home',
      route: '/',
    }];

    let blogPageTitle = null;

    const { match } = this.props;
    const { isBlogRoute } = assignSectionRoutes(match.path);
    const blogUrl = match.url.split('/')[1];

    if (match.params) {
      if (!isBlogRoute) {
        const pathParams = match.path.split('/');
        pathParams.pop();
        pathParams.shift();

        pathParams.forEach((pathParam) => {
          topNav.push({
            label: upperCaseString(replaceHyphensWithSpace(pathParam)),
            route: `/${pathParam}`,
          });
        });
      } else {
        blogPageTitle = (match.url.match(/^\/blog/)) ? T.translate('blogView.mainTitle') : blogPageTitle;

        topNav.push({
          label: 'Blog',
          route: '/blog',
        });

        if (match.params.year && !Number.isNaN(match.params.year)) {
          const year = parseInt(match.params.year);

          /**
           * Don't parse something silly like `/blog/4323243242`
           */
          if (year >= 2017 && year <= new Date().getFullYear()) {
            // eslint-disable-next-line func-names
            const formatDate = function (date, end, pad) {
              date = +date;
              const returnValue = (pad) ? '01' : null;
              return (!Number.isNaN(date) && date > 0 && date <= end) ? date.toString().padStart(2, 0) : returnValue;
            };

            const date = dayjs.utc([
              +match.params.year || dayjs().year(),
              formatDate(match.params.month, 12, true), formatDate(match.params.day, 31, true),
            ].join('-'));

            const datesPadded = {
              day: formatDate(match.params.day, 31),
              month: formatDate(match.params.month, 12),
              year: date.get('year').toString(),
            };

            /**
             * In case someone does something stupid like `/blog/2018/00/12`
             * This is also handled in the router
             */
            if (!datesPadded.month && datesPadded.day) {
              datesPadded.month = '01';
            }

            blogPageTitle = datesPadded.year;

            const monthText = date.format('MMMM');
            const dayText = date.format('dddd Do');

            if (datesPadded.month) {
              topNav.push({
                label: datesPadded.year,
                route: `/blog/${datesPadded.year}`,
              });

              blogPageTitle = monthText;
            }

            if (datesPadded.day) {
              topNav.push({
                label: monthText,
                route: `/blog/${datesPadded.year}/${datesPadded.month}`,
              });

              blogPageTitle = dayText;

              if (match.params.post) {
                blogPageTitle = null;
                topNav.push({
                  label: dayText,
                  route: `/blog/${datesPadded.year}/${datesPadded.month}/${datesPadded.day}`,
                });
              }
            }
          }
        }
      }
    }

    return (
      <Content ref={this.$content} className={styles.view}>
        {preventFouc || ready
          ? (
            <section>
              {
                /* We're using key prop so the component
                  mounts and unmounts on url change and therefore gets new boundaries */
                stickyVRM && isTablet && this.$content.current
                && (
                  <StickyVRM
                    key={match.url}
                    $content={this.$content.current}
                  />
                )
              }
              <div className={styles.content} id="content">
                <div>
                  <Breadcrumbs leftAlign className={styles.topNav} list={topNav} />
                  {blogPageTitle
                    ? <Title large className={styles.mainTitle} element="h1">{blogPageTitle}</Title>
                    : null}
                  {wordpressData
                    ? (
                      <div>

                        {wordpressData.posts !== undefined && wordpressData.posts.length > 0

                          ? (
                            <div>
                              {wordpressData.posts.map((p, index) => (
                                <BlogPost
                                  key={`post-${index}`}
                                  author={p.author}
                                  content={wordpressData.showFull ? p.content : p.excerpt}
                                  date={p.date}
                                  noLink={!!match.params.post}
                                  slug={p.slug}
                                  title={p.title}
                                  wordpressContent={{
                                    className: `${styles.wordpressContent} ${styles.wordpressContent}_content_${blogUrl}`,
                                  }}
                                />
                              ))}
                            </div>
                          )
                          : this.displayPage(wordpressData)}
                      </div>
                    )
                    : <div>{content}</div>}
                </div>
              </div>
              <div className={styles.sideBar} id="sidebar">
                <div className={styles.stickySidebar}>
                  <div className={cx(styles.sideBarSection, 'mw-input mw-input-vrm-white')}>
                    <h3>{T.translate('wordpressView.vehicleLookup.title')}</h3>
                    <p>{T.translate('wordpressView.vehicleLookup.strap')}</p>
                    <VrmCheckerWrapper />
                  </div>
                  {archive && archive.length > 0 && blog
                    ? (
                      <div className={styles.sideBarSection}>
                        <h3>Archives</h3>
                        <ul>
                          {archive.map((x, index) => (
                            <li key={`archive-${index}`}>
                              <Link className="mw-link mw-link-blue mw-link-copy" to={x.route}>{x.label}</Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )
                    : null}
                </div>
              </div>
            </section>
          )
          : <DialogLoader className={styles.dialog} />}
      </Content>
    );
  }
}

Wordpress.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  context: PropTypes.object.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default connect(Wordpress);
